<template>
  <div class="external-page">
    <lazy-hydrate when-visible>
      <ExternalBanner
        :external-class="pageClass"
        @openModal="openModal"
      />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <div class="external-page__blocks">
        <ExternalBlocks
          @openModal="openModal"
        />
      </div>
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <div class="external-page__magnet">
        <external-lead-magnet
          @openModal="showDownloadModal = true"
        />
      </div>
    </lazy-hydrate>

    <download-program-modal
      v-if="showDownloadModal"
      @closeModal="showDownloadModal = false"
    />

    <lazy-hydrate when-visible>
      <div class="external-page__whom">
        <ExternalWhom />
      </div>
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <div class="external-page__license">
        <ExternalLicense />
      </div>
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <div class="external-page__advantages">
        <ExternalAdvantages />
      </div>
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <ExternalResults />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <ExternalStudentResults />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <ExternalTariffs v-if="false" />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <ExternalVideo />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <ExternalReviews />
    </lazy-hydrate>

    <lazy-hydrate whe-visible>
      <exam-form
        title="ЕСТЬ ВОПРОСЫ? <br> СМЕЛО ПИШИТЕ!"
        image="/v2/external-adult/form.webp"
        class="external-page__form"
      />
    </lazy-hydrate>

    <olga-block />

    <faq-accordion-new
      page="externalNew"
      sticker-url=""
    />

    <lazy-hydrate when-visible>
      <external-class-seo
        v-if="pageClass"
        :page-class="pageClass"
      />
    </lazy-hydrate>

    <ExternalModal
      v-if="showModal"
      :type="modalType"
      @close="closeModal"
    />
  </div>
</template>

<script>
import HeadMixin from '@/mixins/HeadMixin';

import LazyHydrate from 'vue-lazy-hydration';
import ExternalBanner from '../../components/v2/external/new/ExternalBanner.vue';
import ExternalBlocks from '../../components/v2/external/new/ExternalBlocks.vue';
import ExternalLeadMagnet from '../../components/v2/external/ExternalLeadMagnet.vue';
import DownloadProgramModal from '../../components/v2/external/DownloadProgramModal.vue';
import ExternalWhom from '../../components/v2/external/new/ExternalWhom.vue';
import ExternalLicense from '../../components/v2/external/new/ExternalLicense.vue';
import ExternalAdvantages from '../../components/v2/external/new/ExternalAdvantages.vue';
import ExternalResults from '../../components/v2/external/new/ExternalResults.vue';
import ExternalStudentResults from '../../components/v2/external/new/ExternalStudentResults.vue';
import ExternalTariffs from '../../components/v2/external/new/ExternalTariffs.vue';
import ExternalVideo from '../../components/v2/external/new/ExternalVideo.vue';
import ExternalReviews from '../../components/v2/external/new/ExternalReviews.vue';
import ExamForm from '../../components/v2/ege/ExamForm.vue';
import FaqAccordionNew from '../../components/v2/common/FaqAccordion/FaqAccordionNew.vue';
import ExternalModal from '../../components/v2/external/new/ExternalModal.vue';
import ExternalClassSeo from '../../components/v2/external/new/ExternalClassSeo.vue';
import OlgaBlock from '../../components/v2/common/OlgaBlock.vue';

export default {
  name: 'ExternalPage',
  components: {
    OlgaBlock,
    ExternalClassSeo,
    LazyHydrate,
    ExternalBanner,
    ExternalBlocks,
    ExternalLeadMagnet,
    DownloadProgramModal,
    ExternalWhom,
    ExternalLicense,
    ExternalAdvantages,
    ExternalResults,
    ExternalStudentResults,
    ExternalTariffs,
    ExternalVideo,
    ExternalReviews,
    ExamForm,
    FaqAccordionNew,
    ExternalModal,
  },
  mixins: [HeadMixin],
  layout: 'DefaultLayoutV2',

  data: () => ({
    // для head
    image: '/v2/external/share-image.jpg',
    headScripts: [{
      // eslint-disable-next-line max-len,vue/max-len
      src: 'https://js.onef.pro/static/reg1f_v1.js?1f_pixel_id=24aed672-c5f3-4e78-ba7e-eed74b860cd1&event_type=visit&product=school_synergy_ru',
      defer: true,
      type: 'text/javascript',
    }],
    canonical: true,

    showDownloadModal: false,
    showModal: false,
    modalType: null,
  }),

  computed: {
    pageClass() {
      const classes = {
        'externat-5-7klass': '5-7',
        'externat-8-9klass': '8-9',
        'externat-10-11klass': '10-11',
      };
      return classes[this.$route.name];
    },
    // для head
    title() {
      if (this.pageClass) {
        return `Программа экстернат с ${this.pageClass} класс в онлайн-школе «Синергия»`;
      }

      return 'Программа Экстернат с 5 по 11 класс в онлайн-школе «Синергия»';
    },
    description() {
      if (this.pageClass) {
        // eslint-disable-next-line max-len,vue/max-len
        return `Пройди обучение экстерном в ${this.pageClass} классах в онлайн-школе «Синергия». Экспресс обучение по программе Экстернат для взрослых и детей`;
      }

      // eslint-disable-next-line max-len,vue/max-len
      return 'Пройди обучение экстерном в онлайн-школе «Синергия». Экспресс обучение по программе Экстернат для взрослых и детей';
    },
  },

  methods: {
    openModal(modalType) {
      this.modalType = modalType;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.modalType = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.external-page {
  display: flex;
  flex-direction: column;
  gap: 200px;
  padding-bottom: 200px;

  background-color: $gray-bg;
  overflow: hidden;

  @include media-down(tablet) {
    gap: 96px;
    padding-bottom: 56px;
  }

  &__blocks {
    margin-top: -100px;

    @include media-down(tablet) {
      margin-top: -40px;
    }
  }

  &__magnet {
    margin-top: -40px;

    @include media-down(tablet) {
      margin-top: -10px;
    }
  }

  &__whom {
    margin-top: -40px;

    @include media-down(tablet) {
      margin-top: 0;
    }
  }

  &__license {
    margin-top: -40px;

    @include media-down(tablet) {
      margin-top: 0;
    }
  }

  &__advantages {
    @include media-down(tablet) {
      margin-top: -10px;
    }
  }

  &__form {
    ::v-deep .ef__sticker {
      display: none;
    }

    ::v-deep .ef__form--input-phone input {
      padding-left: 16px;
    }
  }
}
</style>
